import { Link, useSearchParams } from "react-router-dom";
import Card from "../../layouts/Card";
import white from "/cywe-assets/card/white.png";
import heart from "/cywe-assets/heart/crystal.png";
import Button from "../../layouts/Button";
import { calculateColor } from "../../utils/color";

export default function Results({
	red,
	orange,
	yellow,
	lime,
	green,
	cyan,
	blue,
	purple,
	pink,
}: {
	red: number;
	orange: number;
	yellow: number;
	lime: number;
	green: number;
	cyan: number;
	blue: number;
	purple: number;
	pink: number;
}) {
	// Get redirect url
	const [searchParams, _setSearchParams] = useSearchParams();

	// Calculate Hue using Vector Addition (Circular Mean)
	const { hsl, hex } = calculateColor({
		red,
		orange,
		yellow,
		lime,
		green,
		cyan,
		blue,
		purple,
		pink,
	});

	// Add the additional color parameter
	const nextParams = new URLSearchParams(searchParams);

	nextParams.set("color", hex);

	return (
		<Card bg={white} dim={false}>
			<div className="min-h-screen">
				<div className="min-h-screen flex flex-col items-center justify-center">
					<div
						className="aspect-square max-w-150 w-full bg-blend-multiply bg-contain bg-no-repeat bg-center"
						style={{
							backgroundImage: `url(${heart})`,
							backgroundColor: hsl,
							// The mask clips out any background color spilling into transparent areas:
							WebkitMaskImage: `url(${heart})`,
							maskImage: `url(${heart})`,
							WebkitMaskSize: "contain",
							maskSize: "contain",
							WebkitMaskRepeat: "no-repeat",
							maskRepeat: "no-repeat",
							WebkitMaskPosition: "center",
							maskPosition: "center",
						}}
					/>
				</div>
			</div>
			<div className="absolute bottom-4 right-4">
				<Link to={`/shirt?${nextParams.toString()}`}>
					<Button>Next</Button>
				</Link>
			</div>
		</Card>
	);
}
